import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { toastr } from 'react-redux-toastr';
import { getDataFromAPI } from '../HandleAPICalls/actions';
import parseResponseToOptions, { parseVMCohortOptions } from '../../utils/parseResponseToOptions';
import CreateuserComponent from './component';

class CreateUserContainer extends Component {
  constructor() {
    super();
    this.state = {
      fullName: '',
      mobile: '',
      password: '',
      email: '',
      status: '',
      roleId: null,
      loading: true,
      rolesLoading: true,
      roleList: [],
      vmCohortList: [],
      vmCohortIdColl: [],
      vmCohortLoading: true
    };
  }
  componentDidMount() {
    this.props.getDataFromAPI(
      '/users/roles/all',
      'GET',
      undefined,
      response => {
        console.log('user role response', response);
        this.setState({ roleList: parseResponseToOptions(response.list), rolesLoading: false });
        this.setState({ loading: false });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch manufacturer details');
        this.setState({ loading: false, rolesLoading: false });
      }
    );

    this.props.getDataFromAPI(
      '/vendingmachines/vm-cohorts',
      'GET',
      undefined,
      response => {
        this.setState({
          vmCohortList: parseVMCohortOptions(response.list),
          vmCohortLoading: false,
          loading: false
        });
      },
      err => {
        console.log(err);
        toastr.error('Failed', 'Unable to fetch vending machine cohort details');
        this.setState({ loading: false, vmCohortLoading: false });
      }
    );
  }

  onChangeOfName = event => {
    this.setState({ fullName: event.target.value });
  };

  onChangeOfMobile = event => {
    this.setState({ mobile: event.target.value });
  };

  onChangeOfEmail = event => {
    this.setState({ email: event.target.value });
  };

  onChangeOfPassword = event => {
    this.setState({ password: event.target.value });
  };

  onChangeOfStatus = (event, data) => {
    this.setState({ status: data.value });
  };

  onChangeOfRole = (event, data) => {
    this.setState({ roleId: data.value });
  };

  onChangeOfCohort = (event, data) => {
    this.setState({ vmCohortIdColl: data.value });
  };

  handleSubmit = () => {
    // set loading true
    this.setState({ loading: true });

    const { mobile, password, roleId, fullName, email, vmCohortIdColl } = this.state;

    const payload = {
      mobile,
      password,
      roleId,
      fullName,
      email,
      vmCohortIdColl
    };

    if (fullName && fullName.length < 3) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Product Name is too small');
    }
    if (!roleId) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Please select a role');
    }
    if (!mobile || mobile.length !== 10) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Mobile number is required');
    }
    if (!password || password.length < 6) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Password is too small');
    }

    if (!vmCohortIdColl.length) {
      this.setState({ loading: false });
      return toastr.warning('Invalid', 'Vending machine cohort not assigned');
    }

    this.props.getDataFromAPI(
      '/users/new',
      'POST',
      payload,
      response => {
        toastr.success('Successful', 'Added New User');
        this.setState({ loading: false });
        return this.props.history.push('/users/list');
      },
      err => {
        this.setState({ loading: false });
        toastr.error('Failed', 'Failed to add user');
      }
    );
  };

  handleBack = () => {
    return this.props.history.push('/users/list');
  };

  render() {
    return (
      <CreateuserComponent
        fullName={this.state.fullName}
        mobile={this.state.mobile}
        password={this.state.password}
        email={this.state.email}
        onChangeOfName={this.onChangeOfName}
        onChangeOfMobile={this.onChangeOfMobile}
        onChangeOfEmail={this.onChangeOfEmail}
        onChangeOfPassword={this.onChangeOfPassword}
        onChangeOfStatus={this.onChangeOfStatus}
        onChangeOfRole={this.onChangeOfRole}
        submitting={this.state.loading}
        dropdownLoading={this.state.loading}
        handleSubmit={this.handleSubmit}
        handleBack={this.handleBack}
        rolesLoading={this.state.rolesLoading}
        roleList={this.state.roleList}
        onChangeOfCohort={this.onChangeOfCohort}
        vmCohortList={this.state.vmCohortList}
        vmCohortLoading={this.state.vmCohortLoading}
      />
    );
  }
}

export default withRouter(
  connect(null, {
    getDataFromAPI
  })(CreateUserContainer)
);



// WEBPACK FOOTER //
// ./src/Modules/UsersCreate/container.jsx